import type { PreparedPreviewData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type { UseQueryOptions } from '@tanstack/vue-query'
import type { MaybeRef } from 'vue'
import { getError } from '@autobid/strapi-integration/utils/getError'
import { useQuery } from '@tanstack/vue-query'
import { computed, unref } from 'vue'

export function useDetailsPreview(hash: MaybeRef<string>, options?: UseQueryOptions<PreparedPreviewData | null, Error>) {
  const { locale } = useI18n()
  const { $trpc } = useNuxtApp()
  const queryKey = computed(() => ['detailsPreview', unref(hash), locale.value])

  const queryFn = async () => {
    try {
      return await $trpc.internal.getCarPreview.query({
        hash: unref(hash),
        lang: locale.value,
      })
    }
    catch (error) {
      const { message, code, handled } = getError(error)

      if (!handled) {
        throw createError({ statusCode: code, statusMessage: message })
      }

      return null
    }
  }

  return useQuery({
    queryKey,
    queryFn,
    refetchOnWindowFocus: false,
    ...(options || {}),
  })
}
